(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rosarium-flower-delivery-hub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeCarousel = (carousel) => {
      if (carousel.dataset.carouselInitialized === 'true') return;

      const track = carousel.querySelector('[data-carousel-track]');
      const previousButton = carousel.querySelector('[data-carousel-previous]');
      const nextButton = carousel.querySelector('[data-carousel-next]');
      const firstCard = carousel.querySelector('[data-carousel-card]');

      if (!track || !previousButton || !nextButton || !firstCard) return;

      carousel.dataset.carouselInitialized = 'true';

      const updateButtons = () => {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        previousButton.disabled = track.scrollLeft <= 2;
        nextButton.disabled = track.scrollLeft >= maxScroll - 2;
      };

      const move = (direction) => {
        const styles = window.getComputedStyle(track);
        const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
        const visibleCards = Math.max(1, Math.floor(track.clientWidth / firstCard.getBoundingClientRect().width));
        const step = (firstCard.getBoundingClientRect().width + gap) * visibleCards;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        track.scrollBy({
          left: direction * step,
          behavior: reduceMotion ? 'auto' : 'smooth',
        });
      };

      previousButton.addEventListener('click', () => move(-1));
      nextButton.addEventListener('click', () => move(1));
      track.addEventListener('scroll', updateButtons, { passive: true });

      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(updateButtons);
        observer.observe(track);
      } else {
        window.addEventListener('resize', updateButtons);
      }

      updateButtons();
    };

    const initializeAll = (root = document) => {
      root.querySelectorAll('[data-rosarium-carousel]').forEach(initializeCarousel);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rosarium-local-shop-map"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('local-shop-map')) {
    customElements.define(
      'local-shop-map',
      class extends HTMLElement {
        connectedCallback() {
          const loadButton = this.querySelector('[data-map-load]');
          const media = this.querySelector('[data-map-media]');

          if (!loadButton || !media) return;

          loadButton.addEventListener(
            'click',
            () => {
              const source = this.dataset.mapSrc;
              const title = this.dataset.mapTitle;
              if (!source) return;

              const frame = document.createElement('iframe');
              frame.className = 'rosarium-local-shop-map__frame';
              frame.title = title;
              frame.loading = 'lazy';
              frame.allowFullscreen = true;
              frame.referrerPolicy = 'strict-origin-when-cross-origin';
              frame.src = source;
              media.replaceChildren(frame);
            },
            { once: true },
          );
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();
})();
